import { Component, inject, OnInit } from '@angular/core';
import { Router, NavigationEnd, RouterModule } from '@angular/router';
import { AuthService } from './services/auth.service';
import { map } from 'rxjs';
import { SwUpdate } from '@angular/service-worker';
import { SeoService } from './services/seo.service';
import { CommonModule } from '@angular/common';
import { NavToolbarComponent } from './components/nav-toolbar/nav-toolbar.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatBadgeModule } from '@angular/material/badge';
import { MatBottomSheetModule } from '@angular/material/bottom-sheet';
import { MatButtonModule } from '@angular/material/button';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatChipsModule } from '@angular/material/chips';
import { MatRippleModule, MatNativeDateModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialogModule } from '@angular/material/dialog';
import { MatDividerModule } from '@angular/material/divider';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { ThemeService } from './services/theme.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    NavToolbarComponent,
    RouterModule,
    FormsModule,
    ReactiveFormsModule,
    MatAutocompleteModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    MatRadioModule,
    MatDialogModule,
    MatSnackBarModule,
    MatRippleModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatSnackBarModule,
    MatCardModule,
    MatChipsModule,
    MatCheckboxModule,
    MatButtonToggleModule,
    MatSelectModule,
    MatTableModule,
    MatSortModule,
    MatPaginatorModule,
    MatDividerModule,
    MatIconModule,
    MatProgressBarModule,
    MatProgressSpinnerModule,
    MatBottomSheetModule,
    MatMenuModule,
    MatBadgeModule,
  ],
})
export class AppComponent implements OnInit {
  private router = inject(Router);
  private authService = inject(AuthService);
  private readonly swUpdate = inject(SwUpdate);
  private seoService = inject(SeoService);
  private themeService = inject(ThemeService);
  title = 'jctp-webapp';
  showNavToolbar: boolean = false;

  constructor() {
    // Listen to NavigationEnd events
    this.router.events
      .pipe(
        map((event) => {
          if (event instanceof NavigationEnd) {
            // Check if the current route is /login
            this.showNavToolbar =
              !event.url.toLowerCase().includes('/login') &&
              !event.url.includes('/forgot-password') &&
              !event.url.includes('/verification-code') &&
              !event.url.includes('/new-password') &&
              !event.url.includes('/home') &&
              !event.url.includes('/agreements') &&
              !event.url.includes('/register') &&
              !event.url.startsWith('/faqs');
          }
        })
      )
      .subscribe();
  }

  ngOnInit(): void {
    this.seoService.updateMetaTags([
      {
        name: 'description',
        content: `Johnston’s Connected was founded in the fall of 2022 in Calgary, AB, 
        with a focus and commitment to bring together trust-worthy commercial buyers and sellers of agricultural commodities, 
        allowing for quick and easy access to price discovery and trade execution in the North American grain market`,
      },
      { name: 'author', content: "Johnston's Connected" },
      { name: 'keywords', content: "Johnston's Connected Trading Platform" },
    ]);
    this.seoService.updateTitle("Johnston's Connected Home Page");
    this.swUpdate.versionUpdates.subscribe((event) => {
      // console.log('needs updatee?', event);
      if (event.type === 'VERSION_READY') {
        window.location.reload();
      }
    });
    this.themeService.loadStoredPreference();
    this.authService.autoLogin();
  }

  requestPermission() {
    Notification.requestPermission();
  }
}
